import { scaleColor } from './utils/colors';

const defaultPriceColors = {
  low: '#f0e6c4',
  medium: '#d28b21',
  high: '#d28b21',
  veryHigh: '#c61718'
};

export const getPriceColors = theme => {
  if (theme?.palette?.priceTiers) {
    return theme.palette.priceTiers;
  }

  return defaultPriceColors;
};

export const lightenColor = (color, factor) => scaleColor(color, factor);
